import { MarketProductsState } from './index';
import { IMarketProduct, IMarketProductDisplay, ProductType } from '@/domain/bankwatch';

export const getters = {
  allMarketProducts: (state: MarketProductsState): IMarketProduct[] => {
    return state.allMarketProducts;
  },

  allMarketProductsDisplay: (state: MarketProductsState): IMarketProductDisplay[] => {
    return state.allMarketProducts.map((product) => {
      const productTypes: string[] = [];
      let productCount = 0;

      if (product.mortgage) {
        productTypes.push('Mortgage');
        productCount += Object.keys(product.mortgage).filter(
          (key) => product.mortgage![key as keyof typeof product.mortgage]
        ).length;
      }

      if (product.termDeposit && product.termDeposit.length > 0) {
        productTypes.push('Term Deposit');
        productCount += product.termDeposit.length;
      }

      if (product.creditCard && product.creditCard.length > 0) {
        productTypes.push('Credit Card');
        productCount += product.creditCard.length;
      }

      return {
        ...product,
        productTypes,
        productCount
      };
    });
  },

  selectedMarketProduct: (state: MarketProductsState): IMarketProduct | null => {
    return state.selectedMarketProduct;
  },

  isFetching: (state: MarketProductsState): boolean => {
    return state.isFetching;
  },

  error: (state: MarketProductsState): string | null => {
    return state.error;
  },

  getMarketProductByOrgId: (state: MarketProductsState) => (orgId: string): IMarketProduct | undefined => {
    return state.allMarketProducts.find((product) => product.orgId === orgId);
  },

  marketProductsWithMortgages: (state: MarketProductsState): IMarketProduct[] => {
    return state.allMarketProducts.filter((product) => product.mortgage);
  },

  marketProductsWithTermDeposits: (state: MarketProductsState): IMarketProduct[] => {
    return state.allMarketProducts.filter((product) => product.termDeposit && product.termDeposit.length > 0);
  },

  marketProductsWithCreditCards: (state: MarketProductsState): IMarketProduct[] => {
    return state.allMarketProducts.filter((product) => product.creditCard && product.creditCard.length > 0);
  }
};
